import React, { useState, useEffect } from "react";
import styles from "../styles/Footer.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF, faInstagram } from "@fortawesome/free-brands-svg-icons";
import { subscriberService } from "../services/subscriberService";

const Footer: React.FC = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [subscribers, setSubscribers] = useState<string[]>([]); // admin-only list

  // Auto-hide messages after 5s
  useEffect(() => {
    if (!message) return;
    const timer = setTimeout(() => setMessage(""), 5000);
    return () => clearTimeout(timer);
  }, [message]);

  // Subscribe user
  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      console.log("Sending subscription:", email);
      const res = await subscriberService.subscribe(email);
      console.log("Response:", res); // <-- this should log your backend JSON
      setMessage(res.message);
      setEmail(""); // clear input
    } catch (err: any) {
      console.error(err.response?.data?.message || "Subscription failed");
      setMessage(err.response?.data?.message || "Subscription failed");
    } finally {
      setLoading(false);
    }
  };

  // Unsubscribe user
  const handleUnsubscribe = async () => {
    const trimmedEmail = email.trim();
    if (!trimmedEmail) return setMessage("Enter your email to unsubscribe");

    setLoading(true);
    setMessage("");

    try {
      const res = await subscriberService.unsubscribe(trimmedEmail);
      setMessage(res.message);
      setEmail("");
    } catch (err: any) {
      setMessage(err.response?.data?.message || "Unsubscribe failed");
    } finally {
      setLoading(false);
    }
  };

  // Admin-only: fetch all subscribers
  const fetchSubscribers = async () => {
    try {
      const data = await subscriberService.getAll();
      setSubscribers(data.map((s: any) => s.email));
    } catch (err) {
      console.error("Failed to fetch subscribers", err);
    }
  };

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        {/* Column 1: Subscribe */}
        <div className={styles.column}>
          <h3>Subscribe</h3>
          <p>Get updates about our latest car imports.</p>
          <form className={styles.subscribeForm} onSubmit={handleSubscribe}>
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button type="submit" disabled={loading || !email.includes("@")}>
              {loading ? "Subscribing..." : "Subscribe"}
            </button>
          </form>
          {message && (
            <p
              style={{
                marginTop: "0.5rem",
                color: message.toLowerCase().includes("success") ? "#0f0" : "#f00",
              }}
            >
              {message}
            </p>
          )}

          {/* Admin-only: show subscriber list */}
          {subscribers.length > 0 && (
            <div style={{ marginTop: "1rem" }}>
              <h4>Subscribers:</h4>
              <ul style={{ maxHeight: "150px", overflowY: "auto" }}>
                {subscribers.map((s) => (
                  <li key={s}>{s}</li>
                ))}
              </ul>
            </div>
          )}
        </div>

        {/* Column 2: Contact */}
        <div className={styles.column}>
          <h3>Contact Us</h3>
          <p>Email: info@greystarmotors.com</p>
          <p>Phone: +256 765 275 825</p>
          <p>Address: Krish Mall, Block 122 Spring Road, Bugolobi, RoomNumber 7-8</p>
        </div>

        {/* Column 3: Social + Rights */}
        <div className={styles.column}>
          <h3>Follow Us</h3>
          <div className={styles.socials}>
            <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faFacebookF} size="lg" />
            </a>
            <a
              href="https://www.instagram.com/reel/DGh1BF6J3J5/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faInstagram} size="lg" />
            </a>
          </div>
          <br />
          <br />
          <br />
          <p className={styles.copy}>© {new Date().getFullYear()} nzimbaTech. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
